module.exports = __webpack_public_path__ + "static/media/gh.d9949341.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gh.svg
// module id = 869
// module chunks = 0